// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../generated-types'

import gql from 'graphql-tag'
import { VenueImageGalleryFragmentDoc } from './Components/VenueImageGallery/VenueImageGallery.generated'
import { ResponseHeaderFragmentDoc } from './Components/Response/ResponseHeader/ResponseHeader.generated'
import { ResponseMapFragmentDoc } from './Components/ResponseMap/ResponseMap.generated'
import { SpaceDetailsFragmentDoc } from './Components/SpaceDetails/SpaceDetails.generated'
import { ResponseToolbarFragmentDoc } from './Components/ResponseToolbar/ReponseToolbar.generated'
import { ResponseFragmentDoc } from './Components/Response/Response.generated'
import { GuestFragmentDoc } from '../../Components/Material/Drawer/Drawer.generated'
import * as Urql from 'urql'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
export type VenuePropsFragment = {
  __typename?: 'Venue'
  id: number
  tour3dUrl?: string | null
  name: string
  imageUrl?: string | null
  url?: string | null
  spaceName?: string | null
  longitude?: number | null
  latitude?: number | null
  description?: string | null
  photos?: Array<{ __typename?: 'VenuePhoto'; thumbUrl?: string | null }> | null
  nearestTransit?: {
    __typename?: 'NearestTransit'
    distance_km: number
    station: string
  } | null
  documents?: Array<{
    __typename?: 'VenueDocument'
    name: string
    url: string
  }> | null
  spaceFeatures: Array<{
    __typename?: 'SpaceFeature'
    id?: number | null
    name?: string | null
  }>
  spatialConfigurations: Array<{
    __typename?: 'SpatialConfiguration'
    name?: string | null
    capacity?: number | null
  }>
}

export type VenueResponseFragment = {
  __typename?: 'Interest'
  id: number
  matched: boolean
  guestInitiated: boolean
  recommended: boolean
  matchedAt?: any | null
  message?: {
    __typename?: 'Message'
    seenAt?: any | null
    id: number
    email: string
    phone?: string | null
    declinedAt?: any | null
    creationDate: any
    text: string
    relevancyFit: Types.RelevancyFit
    venue?: {
      __typename?: 'Venue'
      id: number
      tour3dUrl?: string | null
      name: string
      imageUrl?: string | null
      url?: string | null
      spaceName?: string | null
      longitude?: number | null
      latitude?: number | null
      description?: string | null
      photos?: Array<{
        __typename?: 'VenuePhoto'
        thumbUrl?: string | null
      }> | null
      nearestTransit?: {
        __typename?: 'NearestTransit'
        distance_km: number
        station: string
      } | null
      documents?: Array<{
        __typename?: 'VenueDocument'
        name: string
        url: string
      }> | null
      spaceFeatures: Array<{
        __typename?: 'SpaceFeature'
        id?: number | null
        name?: string | null
      }>
      spatialConfigurations: Array<{
        __typename?: 'SpatialConfiguration'
        name?: string | null
        capacity?: number | null
      }>
    } | null
    declinedReasons: Array<{
      __typename?: 'DeclineReason'
      id: string
      text: string
    }>
  } | null
  enquiry: {
    __typename?: 'Enquiry'
    venue?: {
      __typename?: 'Venue'
      id: number
      tour3dUrl?: string | null
      name: string
      imageUrl?: string | null
      url?: string | null
      spaceName?: string | null
      longitude?: number | null
      latitude?: number | null
      description?: string | null
      photos?: Array<{
        __typename?: 'VenuePhoto'
        thumbUrl?: string | null
      }> | null
      nearestTransit?: {
        __typename?: 'NearestTransit'
        distance_km: number
        station: string
      } | null
      documents?: Array<{
        __typename?: 'VenueDocument'
        name: string
        url: string
      }> | null
      spaceFeatures: Array<{
        __typename?: 'SpaceFeature'
        id?: number | null
        name?: string | null
      }>
      spatialConfigurations: Array<{
        __typename?: 'SpatialConfiguration'
        name?: string | null
        capacity?: number | null
      }>
    } | null
    guest?: {
      __typename?: 'Guest'
      firstName: string
      lastName?: string | null
      email?: string | null
      phoneNumber?: string | null
      mobileNumber?: string | null
    } | null
  }
  host: { __typename?: 'User'; id: number; avatar?: string | null }
}

export type MatchWithVenueMutationVariables = Types.Exact<{
  messageId: Types.Scalars['Int']
}>

export type MatchWithVenueMutation = {
  __typename?: 'Mutation'
  ExpressInterest?: {
    __typename?: 'Message'
    status: Types.MessageStatus
    host: {
      __typename?: 'User'
      name?: string | null
      email: string
      mobileNumber?: string | null
      phoneNumber?: string | null
    }
  } | null
}

export type MarkAsSeenMutationVariables = Types.Exact<{
  messageId: Types.Scalars['Int']
  accessSecret: Types.Scalars['String']
}>

export type MarkAsSeenMutation = {
  __typename?: 'Mutation'
  MarkAsSeen: { __typename?: 'Message'; seenAt?: any | null }
}

export type DeclineMessageMutationVariables = Types.Exact<{
  messageId: Types.Scalars['Int']
  accessSecret: Types.Scalars['String']
  reasons: Array<Types.Scalars['String']> | Types.Scalars['String']
  declineSource: Types.DeclineSource
  otherReason?: Types.InputMaybe<Types.Scalars['String']>
}>

export type DeclineMessageMutation = {
  __typename?: 'Mutation'
  DeclineMessage: { __typename?: 'Message'; declinedAt?: any | null }
}

export const VenuePropsFragmentDoc = gql`
  fragment VenueProps on Venue {
    ...VenueImageGallery
    ...ResponseHeader
    ...ResponseMap
    ...SpaceDetails
  }
  ${VenueImageGalleryFragmentDoc}
  ${ResponseHeaderFragmentDoc}
  ${ResponseMapFragmentDoc}
  ${SpaceDetailsFragmentDoc}
`
export const VenueResponseFragmentDoc = gql`
  fragment VenueResponse on Interest {
    ...ResponseToolbar
    id
    matched
    guestInitiated
    recommended
    message {
      seenAt
      ...Response
      venue {
        ...VenueProps
      }
    }
    enquiry {
      venue {
        ...VenueProps
      }
      guest {
        ...Guest
      }
    }
  }
  ${ResponseToolbarFragmentDoc}
  ${ResponseFragmentDoc}
  ${VenuePropsFragmentDoc}
  ${GuestFragmentDoc}
`
export const MatchWithVenueDocument = gql`
  mutation MatchWithVenue($messageId: Int!) {
    ExpressInterest(messageId: $messageId) {
      status
      host {
        name
        email
        mobileNumber
        phoneNumber
      }
    }
  }
`

export function useMatchWithVenueMutation() {
  return Urql.useMutation<
    MatchWithVenueMutation,
    MatchWithVenueMutationVariables
  >(MatchWithVenueDocument)
}
export const MarkAsSeenDocument = gql`
  mutation MarkAsSeen($messageId: Int!, $accessSecret: String!) {
    MarkAsSeen(messageId: $messageId, accessSecret: $accessSecret) {
      seenAt
    }
  }
`

export function useMarkAsSeenMutation() {
  return Urql.useMutation<MarkAsSeenMutation, MarkAsSeenMutationVariables>(
    MarkAsSeenDocument
  )
}
export const DeclineMessageDocument = gql`
  mutation DeclineMessage(
    $messageId: Int!
    $accessSecret: String!
    $reasons: [String!]!
    $declineSource: DeclineSource!
    $otherReason: String
  ) {
    DeclineMessage(
      messageId: $messageId
      accessSecret: $accessSecret
      reasons: $reasons
      declineSource: $declineSource
      otherReason: $otherReason
    ) {
      declinedAt
    }
  }
`

export function useDeclineMessageMutation() {
  return Urql.useMutation<
    DeclineMessageMutation,
    DeclineMessageMutationVariables
  >(DeclineMessageDocument)
}
